import { render } from "./freeTextQuestion.vue?vue&type=template&id=1908048a&scoped=true"
import script from "./freeTextQuestion.vue?vue&type=script&lang=js"
export * from "./freeTextQuestion.vue?vue&type=script&lang=js"

import "./freeTextQuestion.vue?vue&type=style&index=0&id=1908048a&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1908048a"]])

export default __exports__